<template>
  <div class="text-center">
    <v-dialog :value="dialog" width="640" persistent no-click-animation>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ action }} {{ title }}
        </v-card-title>

        <!-- If creating or updating show editing tools -->
        <v-card-text v-if="!isRemoving">
          <v-form ref="frmRegister" v-if="definition" class="mt-5">
            <v-text-field required label="Word" v-model="definition.word"></v-text-field>
            <v-row>
              <v-col cols="12">
                <v-text-field required v-model="definition.definition" label="Definition"></v-text-field>
                <p v-if="isUpdating">Source: {{ definition.source}}</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Else if Removing display different text -->
        <v-card-text v-else>
          <v-row>
            <v-col>
              <br>
              <h3>Really remove {{ definition.word }}?</h3>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="isUpdating" color="info" @click="updateDefinition">
            {{ action }} {{ title }}
          </v-btn>
          <v-btn v-else-if="isRemoving" color="error" @click="removeDefinition">
            {{ action }} {{ title }}
          </v-btn>
          <v-btn :color="( isRemoving? 'success' : 'error' )" @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        title: "Definition",
      }
    },
    props: ["dialog", "definition", "isUpdating", "isRemoving"],
    computed: {
      action() {
        if (this.isRemoving) {
          return 'Remove'
        } else {
          return 'Update'
        }
      },
    },
    methods: {
      updateDefinition() {
        if (this.$refs.frmRegister.validate()) {
          this.$store.dispatch('definitions/update', this.definition)
          this.$emit('cancel')
        }
      },
      removeDefinition() {
        this.$store.dispatch('definitions/remove', this.definition)
        this.$emit('cancel')
      }
    }
  }
</script>